// angular
// 	.module("HeroPRO")
// 	.controller("OfficeInfoController", officeInfoController);
import _ from 'lodash';
import './officeInfo.scss';

/* @ngInject */
export default function officeInfoController($rootScope, $stateParams, UserData, OfficesFactory, HPRoles) {
    const vm = this;
    vm.isEditingInfo = false;
    vm.isEditingContacts = false;
    vm.submitted = 'false';
    vm.officeName = '';
    vm.contactFirstName = '';
    vm.contactLastName = '';

    vm.address = {};

    vm.contact = {};

    init();

    /*= =======================================
	 =            Public Functions            =
	 ======================================== */

    vm.editOfficeInformation = function () {
        vm.isEditingInfo = true;
    };

    vm.editOfficeContacts = function () {
        vm.isEditingContacts = true;
    };

    vm.cancelEditOfficeInformation = function () {
        vm.submitted = 'false';
        vm.isEditingInfo = false;
    };

    vm.cancelEditOfficeContacts = function () {
        vm.submitted = 'false';
        vm.isEditingContacts = false;
        // reset the data
        getOfficeProfile();
    };

    vm.submitOfficeInfo = function (isValid) {
        vm.submitted = 'true';
        if (isValid) {
            const data = {
                ContractorLocationId: $stateParams.accountId,
                LocationDetail: {
                    LocationNickname: vm.officeName,
                    Address: vm.address.street,
                    City: vm.address.city,
                    State: vm.address.state,
                    Zip: vm.address.zip,
                },
            };
            saveOfficeProfile(data);
        }
    };

    vm.submitOfficeContacts = function (isValid) {
        vm.submitted = 'true';
        if (isValid) {
            // the contactInfo directive uses the field PhoneNumber
            // so I need to update the Phone values before returning.
            _.each(vm.locationContactDetails.LeadContacts, (leadContact) => {
                leadContact.Phone = leadContact.PhoneNumber;
            });

            const data = {
                ContractorLocationId: $stateParams.accountId,
                OfficeEmail: vm.contact.Email,
                OfficePhone: vm.contact.PhoneNumber,
                OfficeExtension: vm.contact.Extension,
                OfficeFirstName: vm.contactFirstName,
                OfficeLastName: vm.contactLastName,
                LeadContacts: vm.locationContactDetails.LeadContacts,
            };
            saveOfficeContacts(data);
        }
    };

    vm.addSecondaryLead = function () {
        vm.showAddSecondary = false;
        const newLead = {
            Priority: 2,
            ContactTypeId: 1,
            IsActive: true,
        };
        vm.locationContactDetails.LeadContacts.push(newLead);
    };

    vm.removeSecondaryLead = function () {
        vm.showAddSecondary = true;
        const secondaryLead = _.last(vm.locationContactDetails.LeadContacts);
        if (secondaryLead.ContactId) {
            secondaryLead.IsActive = false;
        } else {
            vm.locationContactDetails.LeadContacts.pop();
        }
    };

    /* -----  End of Public Functions  ------*/

    /*= =======================================
	 =            Private Functions            =
	 ======================================== */
    function init() {
        getOfficeProfile();
    }

    function getOfficeProfile() {
        const data = {
            ContractorLocationId: Number($stateParams.accountId),
        };

        UserData.getUserData().then((response) => {
            const currentRole = _.find(HPRoles, (key, other) => other === response.Roles[0]);

            data.IncludeACHInfo = currentRole.isAdmin;
            OfficesFactory.getOfficeProfile(data).then((response) => {
                vm.cleanOfficeProfile = angular.copy(response.data);
                vm.locationDetail = response.data.LocationDetail;
                vm.locationContactDetails = response.data.LocationContactDetails;
			    vm.showAddSecondary = vm.locationContactDetails.LeadContacts.length === 1;
                _.each(vm.locationContactDetails.LeadContacts, (leadContact) => {
                    leadContact.PhoneNumber = leadContact.Phone;
                });

                vm.officeName = vm.locationDetail.LocationNickname;
                vm.contactFirstName = vm.locationContactDetails.OfficeContactFirstName;
                vm.contactLastName = vm.locationContactDetails.OfficeContactLastName;

                vm.address = {
                    street: vm.locationDetail.Address,
                    city: vm.locationDetail.City,
                    state: vm.locationDetail.State,
                    zip: vm.locationDetail.Zip,
                };
                vm.contact = {
                    Email: vm.locationContactDetails.OfficeContactEmail,
                    PhoneNumber: vm.locationContactDetails.OfficeContactPhone,
                    Extension: vm.locationContactDetails.OfficeContactPhoneExtension,
                };
            });
        });
    }

    function saveOfficeProfile(data) {
        OfficesFactory.saveInfo(data).then(() => {
            // reload the data
            getOfficeProfile();

            if (vm.isEditingInfo) {
                $rootScope.$broadcast('LocationNicknameUpdated', { LocationNickname: vm.locationDetail.LocationNickname });
                vm.isEditingInfo = false;
            }
            vm.submitted = 'false';
        });
    }

    function saveOfficeContacts(data) {
        OfficesFactory.saveContacts(data).then(() => {
            vm.isEditingContacts = false;
            getOfficeProfile();
            vm.submitted = 'false';
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/accounts/offices/info/officeInfoController.js